export var ActionType;
(function (ActionType) {
    ActionType["LIGHT"] = "light";
    ActionType["DARK"] = "dark";
    ActionType["TOGGLE"] = "toggle";
    ActionType["OVERRIDE"] = "override";
})(ActionType || (ActionType = {}));
